<template>
	<div class="dp-pad">
		<img class="dp-pad-bg" src="@/assets/phone.png" alt />
		<div class="dp-pad-iframe">
			<iframe src="https://dp.djplus.cn"></iframe>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {};
		},
		mounted() {},
		methods: {}
	};
</script>
<style lang='scss' scoped>
	.dp-pad {
		&-iframe {
			iframe {
				width: 450px;
				height: 750px;
				border: 0.01rem solid #000;
			}

			text-align: center;
			width: 100%;
			position: absolute;
			top: 180px;
			left: -8px;
		}

		.dp-pad-bg {
			width: 530px;
			height: 900px;
		}
		text-align: center;
		background: url('../assets/partyBack.jpg');
		background-size: 100% 100%;
		background-repeat: no-repeat;
		width: 100%;
		height: 100vh;
		padding-top: 60px;
	}
</style>
